// extracted by mini-css-extract-plugin
export default {"innerWrapper":"SF-z","tooltipWrapper":"TF-z","icon":"UF-z","tooltip":"VF-z","content":"WF-z"};